module.exports = __webpack_public_path__ + "static/img/shiLi-1.c404f54.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shiLi-1.png
// module id = Qm20
// module chunks = 1